import './App.css';

import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './reducers'
import thunk from 'redux-thunk'

import Main from './Main'

//const store = createStore(rootReducer, applyMiddleware(thunk))
const store = createStore(rootReducer,
  compose(
    applyMiddleware(thunk),
    process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
  ))

const user = localStorage.getItem('un');
const tokenId = localStorage.getItem('saat');
const refreshToken = localStorage.getItem('srat');
 
export default function App(props) {
    return (
      <Provider store={store}>
        <Main tokenId={tokenId} user={user} refreshToken={refreshToken} />
      </Provider>
    );  
}